import React from "react";
import { Modal } from "antd";
import { reviewModalConstants, submitModalConstants } from "../constants";
import styles from "../DataInput.module.scss";

interface SubmitTicketModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleOnSubmit: () => void;
  isManager: boolean;
}

const SubmitTicketModal = (props: SubmitTicketModalProps) => {
  const { isOpen, handleClose, handleOnSubmit, isManager } = props;

  return (
    <Modal
      visible={isOpen}
      onCancel={handleClose}
      title={
        isManager
          ? submitModalConstants.APPROVE_TITLE
          : submitModalConstants.SUBMIT_TITLE
      }
      okText={submitModalConstants.SUBMIT_BTN_TXT}
      onOk={handleOnSubmit}
      width={reviewModalConstants.WIDTH}
    >
      <p className={styles.submitModalMessage}>
        {isManager
          ? submitModalConstants.APPROVE_MESSAGE
          : submitModalConstants.SUBMIT_MESSAGE}
      </p>
    </Modal>
  );
};

export default SubmitTicketModal;
